export default __webpack_public_path__ + "static/media/pager-image-small.4716bcbb.jpg";